import { createSlice } from '@reduxjs/toolkit';
import { service } from '../shared/_services/api_service';
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  categoryData: [],
  totalCategory: 0,
  isOpenModal: false,
  isStatusOpenModal: false,
  isImageOpenModal: false,
};

export const bodmasCategorySlice = createSlice({
  name: "bodmasCategory",
  initialState,
  reducers: {
    setBodmasCategoryData(state, { payload }) {
      state.categoryData = payload.result;
      state.totalCategory = payload.total;
    },
    updateBodmasCategoryData(state, { payload }) {
      const objIndex = state.categoryData.findIndex((obj) => obj._id === payload._id);
      if (objIndex >= 0) {
        state.categoryData[objIndex] = payload;
      }
    },
    updateBodmasCategoryImageData(state, { payload }) {
      const objIndex = state.categoryData.findIndex((obj) => obj._id === payload._id);
      if (objIndex >= 0) {
        state.categoryData[objIndex] = payload;
      }
    },
    deleteBodmasCategoryData(state, { payload }) {
      const objIndex = state.categoryData.findIndex((obj) => obj._id === payload);
      if (objIndex >= 0) {
        state.categoryData.splice(objIndex, 1);
      }
    },
    pushBodmasCategoryData(state, { payload }) {
      state.categoryData.unshift(payload);
    },

    isOpenModal(state, { payload }) {
      state.isOpenModal = payload;
    },
    ModalToggle(state) {
      state.isOpenModal = !state.isOpenModal;
    },
    isOpenStatusModal(state, { payload }) {
      state.isStatusOpenModal = payload;
    },
    statusToggle(state) {
      state.isStatusOpenModal = !state.isStatusOpenModal;
    },
    isImageOpenModal(state, { payload }) {
      state.isImageOpenModal = payload;
    },
    ImagestatusToggle(state) {
      state.isImageOpenModal = !state.isImageOpenModal;
    },
  }
});

export const {
  setBodmasCategoryData,
  updateBodmasCategoryData,
  updateBodmasCategoryImageData,
  deleteBodmasCategoryData,
  pushBodmasCategoryData,
  isOpenModal,
  ModalToggle,
  isOpenStatusModal,
  statusToggle,
  isImageOpenModal,
  ImagestatusToggle
} = bodmasCategorySlice.actions;

export default bodmasCategorySlice.reducer;

export function getBodmasCategory(limit = 10, offset = 0, status = '', keyword = '') {
  return async function getBodmasCategoryThunk(dispatch) {
    dispatch(setLoading(true));
    try {
      const response = await service.getBodmasCategory(limit, offset, status, keyword);
      dispatch(setBodmasCategoryData({ result: response.data.categoryData, total: response.data.totalCategory }));
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
      errorHandler(error.response);
    }
  };
}

export function addBodmasCategory(payload) {
  return async function addBodmasCategoryThunk(dispatch) {
    dispatch(setLoading(true));
    try {
      const response = await service.addBodmasCategory(payload);
      dispatch(pushBodmasCategoryData(response.data));
      dispatch(setLoading(false));
      dispatch(isOpenModal(false));
      successHandler('Added Successfully');
    } catch (error) {
      dispatch(setLoading(false));
      errorHandler(error.response);
    }
  };
}

export function updateBodmasCategory(id, payload) {
  return async function updateBodmasCategoryThunk(dispatch) {
    dispatch(setLoading(true));
    try {
      const response = await service.updateBodmasCategory(id, payload);
      dispatch(updateBodmasCategoryData(response.data));
      dispatch(setLoading(false));
      dispatch(isOpenModal(false));
      successHandler('Updated Successfully');
    } catch (error) {
      dispatch(setLoading(false));
      errorHandler(error.response);
    }
  };
}

export function statusUpdateBodmasCategory(id, status) {
  return async function statusUpdateBodmasCategoryThunk(dispatch) {
    dispatch(setLoading(true));
    try {
      const response = await service.statusUpdateBodmasCategory(id, status);
      dispatch(updateBodmasCategoryData(response.data));
      dispatch(setLoading(false));
      dispatch(isOpenStatusModal(false));
      successHandler('Status Updated Successfully');
    } catch (error) {
      dispatch(setLoading(false));
      errorHandler(error.response);
    }
  };
}

export function bodmasCategoryImage(id, image) {
  return async function bodmasCategoryImageThunk(dispatch) {
    dispatch(setLoading(true));
    try {
      const response = await service.bodmasCategoryImage(id, image);
      dispatch(updateBodmasCategoryImageData(response.data));
      dispatch(setLoading(false));
      dispatch(isImageOpenModal(false));
      successHandler('Image Updated Successfully');
    } catch (error) {
      dispatch(setLoading(false));
      errorHandler(error.response);
    }
  };
}

export function deleteBodmasCategory(id) {
  return async function deleteBodmasCategoryThunk(dispatch) {
    dispatch(setLoading(true));
    try {
      await service.deleteBodmasCategory(id);
      dispatch(deleteBodmasCategoryData(id));
      dispatch(setLoading(false));
      successHandler('Deleted Successfully');
    } catch (error) {
      dispatch(setLoading(false));
      errorHandler(error.response);
    }
  };
}
